import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import argocdPlugin from '@roadiehq/backstage-plugin-argo-cd/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import authPlugin from '@backstage/plugin-auth';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import sonarqubePlugin from '@backstage-community/plugin-sonarqube/alpha';
import techRadarPlugin from '@backstage-community/plugin-tech-radar/alpha';
import { navModule } from './modules/nav';
import { authModule } from './modules/auth';
import { homeModule } from './modules/home';
import { jiraModule } from './modules/jira';

export default createApp({
  features: [
    catalogPlugin,
    notificationsPlugin,
    searchPlugin,
    techdocsPlugin,
    scaffolderPlugin,
    argocdPlugin,
    apiDocsPlugin,
    authPlugin,
    githubActionsPlugin,
    sonarqubePlugin,
    techRadarPlugin,
    navModule,
    authModule,
    homeModule,
    jiraModule,
  ],
});
